import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { forceCheck } from 'react-lazyload'
import { withRouter } from 'react-router-dom'
import { compose } from 'redux'
import { LegalInfoFlyOut, StatsItem, StatsLabel } from '../Toolbar'
import SimpleProgressBar, { StyledSimpleProgressBar } from '../../../components/general/SimpleProgressBar'
import { mobile } from '../../../styles/media'
import translate from '../../../helper/translate'
import FlyoutCollectionStatus from '../FlyoutCollectionStatus'

const StatsCollectionStatus = ({ deckCards, deckSlug, location, priceSource, onClick, t }) => {
	const haves = deckCards.filter(item => item.place !== 'note' && item.ownsCard).length
	const total = deckCards.filter(item => item.place !== 'note').length
	const percent = total !== 0 ? haves / total * 100 : 0

	const ref = useRef(undefined)

	useEffect(() => {
		if (location.pathname !== `/deck/${deckSlug}`) {
			ref.current.scrollTo(0, 0)
		}
	}, [location.pathname])

	return (
		<StatsItem hasHover onClick={onClick} onMouseOver={forceCheck}>
			<Inner>
				<div>{haves}<Total> / {total}</Total></div>
				<SimpleProgressBar percent={percent} />
				<StatsLabel>{t('general.haves')}</StatsLabel>
			</Inner>

			<LegalInfoFlyOut ref={ref}>
				<FlyoutCollectionStatus
					deckCards={deckCards}
					deckSlug={deckSlug}
					priceSource={priceSource}
				/>
			</LegalInfoFlyOut>
		</StatsItem>
	)
}

StatsCollectionStatus.propTypes = {
	deckSlug: PropTypes.string.isRequired,
	deckCards: PropTypes.array.isRequired,
	location: PropTypes.object.isRequired,
	onClick: PropTypes.func,
	priceSource: PropTypes.number.isRequired,
	t: PropTypes.func.isRequired
}

StatsCollectionStatus.defaultProps = {
	onClick: null
}

const Inner = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;

	position: relative;

	> div:first-child {
		white-space: nowrap;
	}

	${StyledSimpleProgressBar} {
		position: absolute;
		top: -4px;
		left: 50%;
		transform: translate(-50%);
		width: 80%;

		background: rgba(255, 255, 255, 0.3);

		span {
			background: ${props => props.theme.greenValid};
			height: 2px;
		}
	}

	${mobile`
		${StyledSimpleProgressBar} {
			top: -2px;
		}
	`}
`

export const Total = styled.span`
	color: rgba(255, 255, 255, 0.5);
	font-size: 1rem;
	font-weight: 500;

	${mobile`
		font-size: 0.9rem;
	`}
`

const enhance = compose(
	translate('general'),
	withRouter
)

export default enhance(StatsCollectionStatus)
